import { Box } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import { Table } from '@/components/ats';
import type { DashboardSection } from '../../../types';

type GridRow = Record<string, string>;

// The grid section ("Talent supply & competition") on the shared ATS table, so
// it reads like every other table in the product.
export const GridSection = ({ section }: { section: DashboardSection }) => {
  const g = section.grid;
  if (!g) return null;

  const columns = g.columns.map((header, i) => ({
    Header: () => (
      <Text variant="overhead" truncate>
        {header}
      </Text>
    ),
    accessor: `col${i}`,
    Cell: (cell: { value?: string }) => (
      <Text
        className={
          i === g.accentCol
            ? '!text-primary-900 font-semi-bold'
            : 'text-secondary-700'
        }
      >
        {cell?.value ?? ''}
      </Text>
    ),
  }));

  const data: GridRow[] = g.rows.map((row) =>
    Object.fromEntries(row.map((cell, i) => [`col${i}`, cell]))
  );

  return (
    <Box>
      <Table
        columns={columns}
        data={data}
        tableId={`agentforge-dashboard-grid-${section.title ?? 'grid'}`}
        skipPagination
        layoutStyles={{ border: 'none' }}
        tableStyles={{ width: '100%', tableLayout: 'auto' }}
      />
    </Box>
  );
};
